<template>
  <div>
    <i18n-t
      v-if="isBankTransfer"
      :keypath="type === 'MONTHLY' ? 'plus_monthly_fop_invalid' : 'plus_fop_invalid'"
      tag="p"
    >
      <template #AnnualPrice v-if="type === 'YEARLY'">
        <b>{{ formatCurrency(totalPrice, { divideBy100: false }) }}</b>
      </template>
      <template #MonthlyPrice v-if="type === 'MONTHLY'">
        <b>{{ formatCurrency(totalPrice, { divideBy100: false }) }}</b>
      </template>
    </i18n-t>
    <i18n-t
      v-else-if="!isExpired && !expiresSoon"
      :keypath="
        type === 'MONTHLY'
          ? 'subscription_expired_reactivate_modal__monthly_text_1'
          : 'subscription_expired_reactivate_modal__annual_text_1'
      "
      tag="p"
    >
      <template #AnnualPrice v-if="type === 'YEARLY'">
        <b>{{ formatCurrency(totalPrice, { divideBy100: false }) }}</b>
      </template>
      <template #MonthlyPrice v-if="type === 'MONTHLY'">
        <b>{{ formatCurrency(totalPrice, { divideBy100: false }) }}</b>
      </template>
    </i18n-t>

    <i18n-t
      v-else-if="isExpired"
      :keypath="type === 'MONTHLY' ? 'plus_monthly_fop_expired' : 'plus_fop_expired'"
      tag="p"
    >
      <template #AnnualPrice v-if="type === 'YEARLY'">
        <b>{{ formatCurrency(totalPrice, { divideBy100: false }) }}</b>
      </template>
      <template #MonthlyPrice v-if="type === 'MONTHLY'">
        <b>{{ formatCurrency(totalPrice, { divideBy100: false }) }}</b>
      </template>
    </i18n-t>

    <i18n-t
      v-else-if="expiresSoon"
      :keypath="type === 'MONTHLY' ? 'plus_monthly_fop_expiring' : 'plus_fot_expiring'"
      tag="p"
    >
      <template #AnnualPrice v-if="type === 'YEARLY'">
        <b>{{ formatCurrency(totalPrice, { divideBy100: false }) }}</b>
      </template>
      <template #MonthlyPrice v-if="type === 'MONTHLY'">
        <b>{{ formatCurrency(totalPrice, { divideBy100: false }) }}</b>
      </template>
    </i18n-t>

    <i18n-t
      v-if="nextPaymentDate && isActivationDateNotToday"
      keypath="subscription_billing_info"
      tag="p"
    >
      <template #BillingDate>
        <b>{{ formatDate(nextPaymentDate, { year: 'numeric', month: 'long', day: '2-digit' }) }}</b>
      </template>
    </i18n-t>
  </div>
</template>
<script setup>
import { useFormatting } from '@/composables/useFormatting'

defineProps({
  type: String,
  isExpired: Boolean,
  expiresSoon: Boolean,
  totalPrice: Number,
  isBankTransfer: Boolean,
  nextPaymentDate: String,
  isActivationDateNotToday: Boolean,
})

const { formatCurrency, formatDate } = useFormatting()
</script>
